import React, { Component } from 'react';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from '../../components/Common/Table';
import { dateTimeFormat } from '../../utilities/timeUtility';
import { parseStatus } from './parser';

const itemKey = item => `${item.external_id}_${item.start}`;

export default class ErrorTable extends Component {
  state = {
    columns: this.columns(),
    extraColumns: this.extraColumns(),
  };

  columns() {
    const { timeZone } = window.bta;
    const headers = ['Item', 'Message', 'Qty', 'Start'];

    const lists = this.props.items.map(item => ({
      key: itemKey(item),
      Qty: item.quantity,
      Item: item.product_title,
      Start: moment.tz(item.start, timeZone).format(dateTimeFormat(item['all_day?'])),
      Message: parseStatus(item.status),
    }));

    return { headers, lists };
  }

  extraColumns() {
    const attrs = this.props.items.reduce((all, item) => {
      all[itemKey(item)] = {
        style: item.status === 'ok' ? { display: 'none' } : { border: 'none', background: 'transparent' },
        key: itemKey(item),
      };
      return all;
    }, {});

    return [
      {
        attrs,
        type: 'button',
        content: <FontAwesomeIcon icon="trash" />,
        header: 'remove',
        onClick(e) {
          const id = e.currentTarget.name.split('_')[0],
                key = e.currentTarget.name.split('_remove')[0],
                line = Object.keys(attrs).indexOf(key) + 1;

          if (line) {
            window.xprops.onTrigger('removeItemByLineIndex', line);
          } else {
            window.xprops.onTrigger('removeItems', [id]);
          }
        },
      },
    ];
  }

  render() {
    const { items, show, style } = this.props;

    if (items && items.length) {
      return (
        <div
          className="ptb15"
          style={{
            display: show ? 'block' : 'none',
            borderBottom: '2px solid rgba(255, 255, 255, 0.6)',
            marginBottom: '5px',
            overflow: 'scroll',
            maxHeight: 'calc(80vh)',
          }}
        >
          <Table
            style={style.body}
            columnReverse
            className="fancy"
            items={items}
            columns={this.state.columns}
            extraColumns={this.state.extraColumns}
          />
        </div>
      );
    }
    return '';
  }
}
